<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">
        <section>
          <h1 class="section-heading">
            {{
              type == "update"
                ? ("USERS.UPDATE_TITLE" | translate)
                : ("USERS.ADD_TITLE" | translate)
            }}
          </h1>
          <div class="fields-container">
            @if (type == "update") {
              <div class="field-control">
                <table class="dc-table-list">
                  <tbody>
                    <tr>
                      <td>
                        {{ "ACCOUNT.ACCESS.EN_NAME" | translate }}
                      </td>
                      <td>{{ req.englishName }}</td>
                    </tr>
                    <tr>
                      <td>
                        {{ "ACCOUNT.ACCESS.AR_NAME" | translate }}
                      </td>
                      <td>{{ req.arabicName }}</td>
                    </tr>
                    <tr>
                      <td>
                        {{ "ACCOUNT.ACCESS.NATIONALITY" | translate }}
                      </td>
                      <td>{{ req.nationality }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            }
            <!-- User type ------>
            <div class="field-control">
              <app-boolean
                [label]="'USERS.TYPE' | translate"
                [control]="g.userType"
                [options]="userTypes"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
              />
            </div>
            @if (type == "add") {
              <div class="field-control">
                <app-text-field
                  [label]="'USERS.EN_NAME' | translate"
                  [control]="g.enName"
                >
                </app-text-field>
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="'USERS.AR_NAME' | translate"
                  [control]="g.arName"
                >
                </app-text-field>
              </div>
              <div class="field-control">
                <app-option-field
                  [label]="'USERS.NATIONALITY' | translate"
                  [control]="g.nationality"
                  [lovType]="'COUNTRY'"
                >
                </app-option-field>
              </div>
            }
            <div class="field-control">
              <app-text-field
                [label]="'USERS.EMAIL' | translate"
                [control]="g.email"
              >
              </app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                class="mt-4"
                [label]="'USERS.PHONE' | translate"
                [control]="g.phone"
              >
              </app-text-field>
            </div>
            <!-- Notification prefs ----->

            <div class="field-control">
              <app-checkbox
                [label]="'USERS.NOTIF_TITLE' | translate"
                [options]="[
                  { label: 'USERS.NOTIF.TRANS' | translate, value: 'TRANS' },
                  {
                    label: 'USERS.NOTIF.COO_SVS' | translate,
                    value: 'COO_SVS',
                  },
                  { label: 'USERS.NOTIF.COO_Only' | translate, value: 'COO' },
                  { label: 'USERS.NOTIF.SVS_Only' | translate, value: 'SVS' },
                ]"
                [control]="g.notif"
              />
            </div>

            @if (type == "update") {
              <div class="field-control">
                <app-checkbox
                  [label]="'USERS.ACCESS_TITLE' | translate"
                  [options]="[
                    {
                      label: 'USERS.ACCESS.MEMBERSHIP' | translate,
                      value: 'MEMBERSHIP',
                    },
                    { label: 'USERS.ACCESS.COO' | translate, value: 'COO' },
                    { label: 'USERS.ACCESS.SVS' | translate, value: 'SVS' },
                    { label: 'USERS.ACCESS.LEGAL' | translate, value: 'LEGAL' },
                    { label: 'USERS.ACCESS.INFO' | translate, value: 'INFO' },
                    {
                      label: 'USERS.ACCESS.PAYMENT' | translate,
                      value: 'PAYMENT',
                    },
                     {
                      label: 'USERS.ACCESS.ATA_CARNET' | translate,
                      value: 'ATA_CARNET',
                    }
                  ]"
                  [control]="g.access"
                  [disabled]="false"
                />
              </div>
            }

            <div class="field-control">
              <app-boolean
                [label]="'USERS.ALLOW_VIEW_MY_DOCUMENTS' | translate"
                [control]="g.viewDocument"
                [options]="standardOption"
              />
            </div>

             <div class="field-control">
              <app-boolean
                [label]="'USERS.ADMIN_USER' | translate"
                [control]="g.admin"
                [options]="standardOption"
              />
            </div>
            <!-- Save button --->
            <div class="btn-section buttons-group">
              @if (!submitLoader) {
                <app-button
                  type="button"
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'BUTTONS.SAVE' | translate"
                  (onBtnClick)="submit()"
                >
                </app-button>
                <app-button
                  type="button"
                  classesName="card-edge-cut-white btn-width-auto"
                  [label]="'BUTTONS.CANCEL' | translate"
                  (onBtnClick)="cancel()"
                >
                </app-button>
              }
              @if (submitLoader) {
                <app-button
                  type="button"
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'PLEASE_WAIT' | translate"
                  [disabled]="true"
                ></app-button>
              }
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
